/**
 * Central tracking helper for the canonical lead event.
 *
 * Pushes `ael_vehicle_created` into the dataLayer exactly once per
 * successful /user/add-vehicle-manually response.  Every call-site
 * uses this instead of an inline dataLayer.push so the event shape
 * stays consistent and changes only need to happen here.
 *
 * @param {Object} opts
 * @param {string} opts.vehicleId    – Backend vehicle ID (json.id)
 * @param {string} opts.entrypoint   – Page/flow that created the lead
 *   e.g. "auto-bewerten" | "auto-verkaufen" | "home" | "marken"
 *        | "fahrgestellnummer-pruefen" | "account" | "anmelden"
 * @param {string} [opts.sourceFlow] – Optional finer context
 *   e.g. "fin_lookup" | "manual_entry" | "anmelden_direct"
 * @param {string} [opts.method]     – How the vehicle was added
 *   e.g. "add-vehicle-manually" (default, only variant today)
 */
export default function trackVehicleCreated({
  vehicleId,
  entrypoint,
  sourceFlow,
  method = "add-vehicle-manually",
}) {
  if (typeof window === "undefined" || !vehicleId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "ael_vehicle_created",
    vehicleId,
    entrypoint,
    sourceFlow: sourceFlow ?? null,
    method,
  });
}
